import React, { useState } from 'react'
import Modal from '@components/common/modal/Modal'
import { Button, Checkbox, Input, LinkText } from '@components/common/form'
import FlexContainer from '@components/common/FlexContainer'
import XSpacing from '@components/common/XSpacing'
import { BestPracticeCategory } from '@types'

interface Props {
  category: Partial<BestPracticeCategory> | null
  onSave: (cat: Partial<BestPracticeCategory>) => void
  isSavingCategory: boolean
  onClose: () => void
}

const BestPracticeCategoryModal: React.FC<Props> = ({
  category,
  onSave,
  isSavingCategory,
  onClose,
}) => {
  const [name, setName] = useState(category?.name ?? '')
  const [active, setActive] = useState(category?.active ?? true)

  const handleSave = async () => {
    if (!name.trim()) {
      return
    }
    onSave({ ...category, name: name.trim(), active })
  }

  const title = category?.id ? `Edit ${category.name}` : 'New Category'

  return (
    <Modal
      title={title}
      hideModal={onClose}
      color="#001940"
      maxWidth="400px"
      width="400px"
    >
      <Input
        label="Name"
        value={name}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setName(e.target.value)
        }
      />
      <Checkbox
        checked={active}
        label="Active"
        marginBottom="20px"
        value="active"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setActive(e.target.checked)
        }
      />
      <FlexContainer justifyContent="flex-end" alignItems="center">
        <LinkText label="Cancel" onClick={onClose} color="#b30303" />
        <XSpacing width="40px" />
        <Button
          label={isSavingCategory ? 'Saving…' : 'Save Category'}
          onClick={handleSave}
        />
      </FlexContainer>
    </Modal>
  )
}

export default BestPracticeCategoryModal
